export default {"src":"/_next/static/media/info.7d3d3a1b.svg","height":17,"width":16};